module.exports = __webpack_public_path__ + "img/9788959642113.81e9ff2c.jpg";